import { Grid } from "@mui/material"
import heartIcon from "img/heart_icon.png";
import { StatsLabels } from "locale/es";
import { useSelector } from 'react-redux'
import { isEmptyObj } from "utils/HelperFunctions";
import SectionHeaderImageIcon from "../SectionHeaderImageIcon";
import PerDayMinAndMaxFrequencyInMonth from "./PerDayMinAndMaxFrequencyInMonth";
// import PerHourMinAndMaxFrequencyInWeek from "./PerHourMinAndMaxFrequencyInWeek";
import PerHourTotalInDay from "./PerHourTotalInDay"
import PerMonthIntensity from "./PerMonthIntensity";

const HeartStats = () => {
  const patientId = useSelector(({ patient }) => patient.id)

  // TODO: Both chart components code is identical except for the states and methods they use. Create a custom hook
  return (
    <>
      {!isEmptyObj(patientId) &&
        <Grid container justifyContent='center' spacing={2} >
          <SectionHeaderImageIcon icon={heartIcon} sectionTitle={StatsLabels.HR} />
          <Grid item >
            {/* <PerHourMinAndMaxFrequencyInWeek /> */}
            <PerHourTotalInDay />
          </Grid>
          <Grid item >
            <PerDayMinAndMaxFrequencyInMonth />
          </Grid>
          <Grid item >
            <PerMonthIntensity />
          </Grid>
        </Grid>
      }
    </>
  )
}

export default HeartStats